<template>
    <div class="modal hide fade in" id="modalEnvio" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Documento Principal</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeModal">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                        <div class="row">
                            <div class="form-group col-12">
                                <label>Área</label>
                                <input type="text" class="form-control" v-model="Datos.Area.Nombre" readonly/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12">
                                <label>Tipo de Documento</label>
                                <input type="text" class="form-control" v-model="Datos.TipoDocumento.Nombre" readonly/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-6">
                                <label>Año</label>
                                <input type="text" class="form-control" v-model="Datos.Anio" readonly/>
                            </div>
                            <div class="form-group col-6">
                                <label>Consecutivo</label>
                                <input type="text"  class="form-control" v-model="Datos.Consecutivo" readonly/>
                            </div>
                        </div>     
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" id="botonCancelar" >Aceptar</button>
                    
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        Datos: Object
    },
    methods: {
        Mostrar: function () {
            $('#modalEnvio').modal('show');
            $('#botonCancelar').unbind('click').click(this.ModalClose);
            $('#closeModal').unbind('click').click(this.ModalClose);
            },
        ModalClose: function(){
            $('#modalEnvio').modal('hide');
            //$('#modalSolicitud').modal('dispose');
            this.$emit('estado', false);
        },
    },
    mounted(){
        this.Mostrar();
    }
    
}
</script>

<style scoped>
input[type="text"]:read-only {
    background: #504f54;
  }

input[type="text"]:read-only:focus {
      color: #fff;
    }
</style>


// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Inventario/infoDocumentoPrincipal.vue